import { Link } from 'react-router-dom'
import DocLayout from '../components/docs/DocLayout'
import { pageTemplates } from '../content/templates'
import { findComponent } from '../content/components'
import Cased from '@/components/ui/Cased'

export default function TemplatesPage() {
  return (
    <DocLayout
      eyebrow="Templates"
      title="Templates"
      intro="Whole pages built from MDS components, in your chosen mission and theme. Start a site from one, as React or as plain HTML."
      wide
    >
      <section className="doc-section">
        <h2 className="mds-visually-hidden">
          <Cased>All templates</Cased>
        </h2>
        <ul className="tpl-grid">
          {pageTemplates.map((template) => (
            <li key={template.id} className="tpl-card">
              <img className="tpl-card__thumb" src={`/mds/design/svg/templates/${template.id}.svg`} alt="" loading="lazy" />
              <h3 className="tpl-card__title">
                <Link className="tpl-card__link" to={`/templates/${template.id}`}>
                  {template.name}
                </Link>
              </h3>
              <p>{template.summary}</p>
              <p className="mds-hint">
                {template.components
                  .map((id) => findComponent(id)?.name)
                  .filter(Boolean)
                  .join(', ')}
              </p>
            </li>
          ))}
        </ul>
      </section>
    </DocLayout>
  )
}
